module.exports = __webpack_public_path__ + "media/info/info-notification-3fd6b17e.svg";